<template>
  <generic-modal :title="$t('password recovery')" ref="generic_modal">
    <div class="field">
      <label class="label">{{ $t("enter your email") }}</label>
      <div class="control">
        <input class="input" type="text" v-model="meta.email" />
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="send"
        :disabled="is_form_invalid"
      >
        <span class="icon"><i class="fa fa-send"></i></span>
        <span>{{ $t("send") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon"><i class="fa fa-close"></i></span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, generate_error_message_text, success_message } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "PasswordRecoveryModal",
  components: { GenericModal },
  props: {
    enterprise: {
      type: String,
      required: true,
    },
    // module_settings: {
    //   type: Object,
    //   required: true,
    // },
  },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return true;
      return !v.meta.email;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    send() {
      let v = this;
      let data = { ...v.meta, enterprise: v.enterprise };

      put("/system/authentication/password-recovery", data)
        .then(() => {
          success_message(v.$t("password recovery email sent"));
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        email: "",
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
